export const copyToClipboard = async (stringToCopy: string) => {
  try {
    const clipboard = navigator?.clipboard;

    if (clipboard) {
      await clipboard.writeText(stringToCopy);
      return;
    }

    const textArea = document.createElement('textArea') as HTMLTextAreaElement;
    textArea.value = stringToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand?.('copy');
    document.body.removeChild(textArea);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error ?? 'Could not copy to clipboard');
  }
};
